/* Editable sample copy. No AI requests or automatic tab rotation. */
if (!customElements.get('seolab-voice-examples')) {
  class SeolabVoiceExamples extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.abortController?.abort();
      if (!this.tabs.length) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.activate(tab);
      }, options);
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next], true);
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find((item) => item.dataset.blockId === event.detail?.blockId);
        if (tab) this.activate(tab);
      }, options);
      this.activate(this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
    }
    disconnectedCallback() { this.abortController?.abort(); }
    activate(selectedTab, focus = false) {
      const panelId = selectedTab.getAttribute('aria-controls');
      this.tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.hidden = !active;
        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      if (focus) selectedTab.focus();
    }
  }
  customElements.define('seolab-voice-examples', SeolabVoiceExamples);
}
